function _array_like_to_array(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _array_with_holes(arr) {
    if (Array.isArray(arr)) return arr;
}
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _async_to_generator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _iterable_to_array_limit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _non_iterable_rest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _object_without_properties(source, excluded) {
    if (source == null) return {};
    var target = _object_without_properties_loose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function _sliced_to_array(arr, i) {
    return _array_with_holes(arr) || _iterable_to_array_limit(arr, i) || _unsupported_iterable_to_array(arr, i) || _non_iterable_rest();
}
function _unsupported_iterable_to_array(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _array_like_to_array(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _array_like_to_array(o, minLen);
}
function _ts_generator(thisArg, body) {
    var f, y, t, _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(g && (g = 0, op[0] && (_ = 0)), _)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
import { request } from "graphql-request";
import { nanoid } from "nanoid";
import { useCallback, useEffect, useMemo, useRef } from "react";
import useSWR from "swr";
import useSWRInfinite from "swr/infinite";
import { config } from "../config";
import { ERROR_CODES, FILTER_TYPES } from "../types";
import { Errors, mapApiRoute, MFA, reportRequest, Validators } from "../utils";
import { mapAdminApiRoute } from "../utils/api-routes-mapper";
import { getRevision } from "../utils/revision";
import { AuthServiceProvider, Emitter } from "../services"; // Relative path for testing
import { useAuth } from "./useAuth";
var offsetPagination = function(page, pageSize) {
    return {
        limit: pageSize,
        offset: page * pageSize
    };
};
var requestFinished = function() {
    requestAnimationFrame(function() {
        return MFA.setIsPending(false);
    });
};
var renewExpiredAccessToken = function() {
    return _async_to_generator(function() {
        var now, token, _token_expires_at, expiresAt, isTokenExpired;
        return _ts_generator(this, function(_state) {
            switch(_state.label){
                case 0:
                    now = Date.now();
                    return [
                        4,
                        new AuthServiceProvider().getAccessToken()
                    ];
                case 1:
                    token = _state.sent();
                    expiresAt = ((_token_expires_at = token === null || token === void 0 ? void 0 : token.expires_at) !== null && _token_expires_at !== void 0 ? _token_expires_at : 0) * 1000;
                    isTokenExpired = !(token === null || token === void 0 ? void 0 : token.access_token) || expiresAt <= now;
                    if (!isTokenExpired) return [
                        3,
                        3
                    ];
                    return [
                        4,
                        new AuthServiceProvider().renewAccessToken()
                    ];
                case 2:
                    _state.sent();
                    _state.label = 3;
                case 3:
                    return [
                        2
                    ];
            }
        });
    })();
};
var cursorPagination = function(param) {
    var cursor = param.cursor, _param_orderBy = param.orderBy, orderBy = _param_orderBy === void 0 ? [] : _param_orderBy, pageSize = param.pageSize, _where = param.where;
    // The only cursor property is "timestamp" so far
    var CURSOR_NAME = "timestamp";
    var limit = pageSize ? pageSize + 1 : pageSize;
    var cursorSortRule = orderBy.find(function(prop) {
        return prop && CURSOR_NAME in prop;
    });
    var direction = cursorSortRule ? cursorSortRule[CURSOR_NAME] : "desc";
    var filterType = direction === "desc" ? FILTER_TYPES.lte : FILTER_TYPES.gt;
    var where = typeof cursor == "boolean" ? _where : _object_spread_props(_object_spread({}, _where), {
        timestamp: _object_spread_props(_object_spread({}, _where === null || _where === void 0 ? void 0 : _where.timestamp), _define_property({}, filterType, cursor))
    });
    return {
        limit: limit,
        where: where
    };
};
var getRequestParams = function() {
    var _param = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    var cursor = _param.cursor, page = _param.page, pageSize = _param.pageSize, props = _object_without_properties(_param, [
        "cursor",
        "page",
        "pageSize"
    ]);
    if (Validators.isNumber(pageSize) && pageSize > 0) {
        if (cursor) {
            return _object_spread({}, props, cursorPagination(_object_spread_props(_object_spread({}, props), {
                cursor: cursor,
                pageSize: pageSize
            })));
        } else {
            return _object_spread({}, props, offsetPagination((page || 1) - 1, pageSize));
        }
    }
    return _object_spread({}, props);
};
var getRequestHeaders = function(param) {
    var accountId = param.accountId;
    return _async_to_generator(function() {
        var headers, token, apiKey;
        return _ts_generator(this, function(_state) {
            switch(_state.label){
                case 0:
                    headers = {
                        "X-Neru-TraceId": nanoid()
                    };
                    return [
                        4,
                        new AuthServiceProvider().getAccessToken()
                    ];
                case 1:
                    token = _state.sent();
                    if (token) {
                        headers.Authorization = "Bearer ".concat(token.access_token);
                    }
                    apiKey = accountId || localStorage.getItem("vch.account_id");
                    if (apiKey) {
                        headers["X-Neru-ApiAccountId"] = apiKey;
                    }
                    if ((import.meta.env.VITE_BYPASS_AUTH || import.meta.env.MODE === "development") && import.meta.env.VITE_HASURA_SECRET) {
                        headers["X-Hasura-Admin-Secret"] = import.meta.env.VITE_HASURA_SECRET;
                    }
                    return [
                        2,
                        headers
                    ];
            }
        });
    })();
};
var getFetcher = function(options, accountId) {
    var _options_apiUrl;
    var url = (_options_apiUrl = options === null || options === void 0 ? void 0 : options.apiUrl) !== null && _options_apiUrl !== void 0 ? _options_apiUrl : config.graphqlApiUrl;
    var apiUrl = url;
    if (getRevision().appName === "admin") {
        var isMock = import.meta.env.MODE !== "production" && import.meta.env.VITE_MOCK;
        apiUrl = isMock ? url : mapAdminApiRoute(url);
    } else if ((options === null || options === void 0 ? void 0 : options.withRouteMapper) !== false) {
        apiUrl = mapApiRoute(url);
    }
    if (!apiUrl) {
        throw new Error("Missing GraphQL API URL.");
    }
    var fetcher = function(key) {
        return _async_to_generator(function() {
            var _key, queryString, params, requestParams, requestHeaders, error, errorClass;
            return _ts_generator(this, function(_state) {
                switch(_state.label){
                    case 0:
                        _key = _sliced_to_array(key, 2), queryString = _key[0], params = _key[1];
                        requestParams = getRequestParams(params);
                        return [
                            4,
                            renewExpiredAccessToken()
                        ];
                    case 1:
                        _state.sent();
                        return [
                            4,
                            getRequestHeaders({
                                accountId: accountId
                            })
                        ];
                    case 2:
                        requestHeaders = _state.sent();
                        _state.label = 3;
                    case 3:
                        _state.trys.push([
                            3,
                            5,
                            ,
                            6
                        ]);
                        MFA.setIsPending(true);
                        return [
                            4,
                            request(apiUrl, queryString, requestParams, requestHeaders)
                        ];
                    case 4:
                        return [
                            2,
                            _state.sent()
                        ];
                    case 5:
                        error = _state.sent();
                        errorClass = Errors.getErrorClass(error);
                        reportRequest(error, {
                            body: requestParams,
                            headers: requestHeaders,
                            method: "POST",
                            query: queryString,
                            url: apiUrl
                        });
                        throw errorClass;
                    case 6:
                        return [
                            2
                        ];
                }
            });
        })();
    };
    return fetcher;
};
var getQueryParams = function(params) {
    if (params) {
        // cursorPoints exist in list state but should be ignored in query
        var _ = params.cursorPoints, includeFields = params.includeFields, rest = _object_without_properties(params, [
            "cursorPoints",
            "includeFields"
        ]);
        return _object_spread({}, rest, includeFields);
    }
    return {};
};
export var useQuery = function(query, params, options) {
    var _useAuth = useAuth(), accountId = _useAuth.accountId, logout = _useAuth.logout;
    var bust = useRef(Date.now());
    var queryParams = getQueryParams(params);
    var fetcher = getFetcher(options, accountId);
    var swrKey = (options === null || options === void 0 ? void 0 : options.skip) ? null : (options === null || options === void 0 ? void 0 : options.noCache) ? [
        query,
        queryParams,
        bust.current
    ] : [
        query,
        queryParams
    ];
    return useSWR((options === null || options === void 0 ? void 0 : options.skip) ? null : swrKey, fetcher, {
        onError: requestFinished,
        onErrorRetry: function(error, _, __, revalidate, param) {
            var retryCount = param.retryCount;
            return _async_to_generator(function() {
                var errorClass;
                return _ts_generator(this, function(_state) {
                    errorClass = Errors.getErrorClass(error);
                    if (retryCount >= 2) {
                        Emitter.emit("error", errorClass);
                        return [
                            2
                        ];
                    }
                    if ((errorClass === null || errorClass === void 0 ? void 0 : errorClass.code) === ERROR_CODES.denied) {
                        // Logout user if token is expired. Some requests are public and don't require token.
                        logout();
                    }
                    setTimeout(function() {
                        return revalidate({
                            retryCount: retryCount
                        });
                    }, 1000);
                    return [
                        2
                    ];
                });
            })();
        },
        onSuccess: requestFinished,
        revalidateOnFocus: Boolean(options === null || options === void 0 ? void 0 : options.revalidateOnFocus)
    });
};
export var useQueryInfinite = function(query, params, options) {
    var accountId = useAuth().accountId;
    var fetcher = useMemo(function() {
        return getFetcher(options, accountId);
    }, [
        accountId,
        options
    ]);
    var dataKey = options.dataKey;
    var _useSWRInfinite = useSWRInfinite(function(index, previousPageData) {
        if (previousPageData && !previousPageData[dataKey] || (options === null || options === void 0 ? void 0 : options.skip)) {
            return null;
        }
        return [
            query,
            _object_spread_props(_object_spread({}, getQueryParams(params)), {
                page: index + 1
            })
        ];
    }, fetcher, {
        onError: requestFinished,
        onSuccess: requestFinished,
        revalidateFirstPage: false,
        revalidateIfStale: false,
        revalidateOnFocus: false
    }), data = _useSWRInfinite.data, error = _useSWRInfinite.error, isValidating = _useSWRInfinite.isValidating, mutate = _useSWRInfinite.mutate, setSize = _useSWRInfinite.setSize, size = _useSWRInfinite.size;
    useEffect(function() {
        if ((params === null || params === void 0 ? void 0 : params.page) && (params === null || params === void 0 ? void 0 : params.page) !== size) {
            setSize(params.page);
        }
    }, [
        params === null || params === void 0 ? void 0 : params.page,
        setSize,
        size
    ]);
    return {
        data: data,
        error: error,
        isValidating: isValidating,
        mutate: mutate
    };
};
export var useMutation = function(query) {
    var accountId = useAuth().accountId;
    var mutationRequest = useCallback(function(query, params) {
        return _async_to_generator(function() {
            var requestHeaders;
            return _ts_generator(this, function(_state) {
                switch(_state.label){
                    case 0:
                        return [
                            4,
                            getRequestHeaders({
                                accountId: accountId
                            })
                        ];
                    case 1:
                        requestHeaders = _state.sent();
                        return [
                            2,
                            request(config.graphqlApiUrl, query, params, requestHeaders)
                        ];
                }
            });
        })();
    }, [
        accountId
    ]);
    if (!config.graphqlApiUrl) {
        throw new Error("Missing GraphQL API URL.");
    }
    return function() {
        var params = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
        return mutationRequest(query, params);
    };
};

//# sourceMappingURL=useGraphQLApi.js.map